export default {
	"common": {
		"edit": "แก้ไข",
		"welcome_message": "ขอต้อนรับสู่ ELSA สำหรับองค์กร",
		"slogan": "พูดภาษาอังกฤษอย่างคล่องแคล่ว ง่ายดายและมั่นใจ",
		"invited_by": "เชิญโดย",
		"agree_to": "ฉันยอมรับ",
		"terms_and_conditions": "ข้อกำหนดและเงื่อนไขของ ELSA",
		"search": "ค้นหา",
		"email": "อีเมล",
		"cancel": "ยกเลิก",
		"save": "บันทึก",
		"or": "หรือ",
		"account_confirmed": "บัญชีของคุณได้รับการยืนยันแล้ว.",
		"no_values": "ไม่แสดงค่า",
		"terms_and_privacy_policy": "ข้อกำหนดและนโยบายความเป็นส่วนตัว",
		"continue": "ดำเนินการต่อ",
		"invite": "เชิญ",
		"generic_error_message": "บางอย่างไม่ถูกต้อง ลองใหม่ในภายหลัง",
		"error_duplidate_group_name": "มีชื่อชั้นเรียนซ้ำในไฟล์",
		"login": "เข้าสู่ระบบ",
		"and": "และ",
		"terms_of_use": "ข้อกำหนดการใช้งาน",
		"privacy_policy": "นโยบายความเป็นส่วนตัว",
		"name": "ชื่อ",
		"view_list": "ดูรายการ",
		"total": "รวม",
		"lessons": "บทเรียน",
		"hours": "ชั่วโมง",
		"average": "เฉลี่ย",
		"lessons_per_day": "บทเรียนต่อวัน",
		"minutes_per_day": "นาทีต่อวัน",
		"pending_invites": "คำเชิญรอการตอบรับ",
		"invite_success": "การเชิญได้รับการตอบรับ",
		"invite_not_success": "คำเชิญไม่สามารถตอบรับได้",
		"invite_send_not_success": "คำเชิญไม่สามารถส่งได้ ",
		"no_invite_seleted": "ไม่มีคำเชิญที่เลือก",
		"select_all": "เลือกทั้งหมด",
		"minutes": "นาที",
		"warnings": {
			"no_report_data": "ไม่สามารถดึงรายงาน ลองอีกครั้ง",
			"session_expired": "เซสชั่นหมดอายุ โปรดเข้าสู่ระบบ"
		},
		"resend_invite": "ส่งคำเชิญซ้ำ",
		"remove_invite": "ลบคำเชิญที่รอการตอบรับ",
		"export_report": "Export รายงาน",
		"export_assessment": "Export ผลการประเมิน",
		"lesson_detail": "รายละเอียดบทเรียน",
		"file_type_not_allowed": "ประเภทไฟล์ไม่ได้รับอนุญาต",
		"import": "นำเข้า",
		"assessment-history": "ประวัติผลการประเมิน"
	},
	"date_interval_picker": {
		"start_end_date": "วันที่เริ่มต้นและสิ้นสุด",
		"save": "บันทึก",
		"cancel": "ยกเลิก",
		"this_month": "เดือนนี้",
		"apply": "ปรับใช้"
	},
	"date_picker": {
		"start_date": "วันที่เริ่มต้น",
		"end_date": "วันที่สิ้นสุด",
		"to": "ถึง",
		"last_week": "สัปดาห์ที่แล้ว",
		"last_month": "เดือนที่แล้ว",
		"last_three_months": "3 เดือนที่แล้ว",
		"last_six_months": "6 เดือนที่แล้ว",
		"last_year": "ปีที่แล้ว",
		"daily": "รายวัน",
		"weekly": "รายสัปดาห์",
		"monthly": "รายเดือน"
	},
	"company_labels": {
		"average_lessons": "จำนวนวันที่ฝึกต่อสัปดาห์",
		"all_users": "พนักงานทั้งหมด",
		"groups": "ทีม",
		"teachers": "หัวหน้าทีม",
		"remove_teacher_from_organization": "ลบหัวหน้าออกจากองค์กร",
		"remove_student_from_organization": "ลบพนักงานออกจากองค์กร",
		"remove_student_from_group": "ลบนักเรียนออกจากทีม",
		"active_students": "พนักงานที่แอคทีฟ",
		"teacher": "หัวหน้าทีม",
		"students": "พนักงาน",
		"student": "พนักงาน",
		"all_groups": "ทีมทั้งหมด",
		"edit_group": "แก้ไขทีม",
		"add_to_group_title": "เพิ่มเข้าสู่ทีม",
		"add_to_group": "ทีมใหม่",
		"import_class_success_title": "{numberClassesImported} ทีม[s] ถูกสร้างสำเร็จ",
		"add_to_group_success": "ผู้ใช้ถูกเพิ่มเข้าสู่ทีม",
		"add_to_group_warning": "ผู้ใช้ไม่สามารถถูกเพิ่มเข้าสู่ทีม",
		"remove_from_class_success": "ผู้ใช้ถูกลบออกจากทีมแล้ว",
		"remove_from_class_warning": "ไม่สามารถลบผู้ใช้ออกจากทีมได้",
		"assign_license_to_user_success": "มอบหมายใบอนุญาตให้ผู้ใช้เรียบร้อยแล้ว",
		"assign_license_to_user_warning": "มอบหมายใบอนุญาตให้ผู้ใช้ไม่สำเร็จ",
		"create_new_group": "สร้างทีมใหม่",
		"no_groups_yet": "คุณยังไม่มีทีม",
		"no_students_yet": "คุณยังไม่มีพนักงาน.",
		"create_group": "สร้างทีม",
		"import_groups": "นำเข้าทีม",
		"import_groups_success": "ทีมถูกสร้างสำเร็จ",
		"import_users_to_groups_success": "นำพนักงานเข้าสู่ทีมสำเร็จ",
		"group_title": "ชื่อทีม",
		"group_name": "ชื่อทีม",
		"group_details": "รายละเอียดทีม",
		"step_group_details": "{step}. รายละเอียดทีม",
		"no_teachers_available": "ไม่มีหัวหน้าให้เลือก",
		"all_teachers": "หัวหน้าทั้งหมด",
		"all_students": "พนักงานทั้งหมด",
		"upload_emails": "นำพนักงานเข้าสู่ทีม",
		"errors": {
			"please_provide_group_name": "โปรดใส่ชื่อทีม",
			"please_provide_teacher_name": "โปรดใส่ชื่อหัวหน้า"
		},
		"add_students": "เพิ่มพนักงาน",
		"group_overview": "ภาพรวมทีม",
		"group_teacher": "หัวหน้าทีม",
		"will_be_added_students": "พนักงาน {numberOfUsers} คนจะถูกเพิ่มเข้าสู่ทีมเมื่อคุณสร้างมันเสร็จ.",
		"student_consent_to_class": "พนักงาน {numberOfUsers} คนจะถูกเพิ่มเข้าสู่ทีมโดยอัตโนมัติ",
		"students_list": "รายชื่อพนักงาน",
		"your_group_was_created": "ทีมของคุณถูกสร้างแล้ว,",
		"error_when_inviting": "แต่มีข้อผิดหลาดในการเชิญผู้ใช้ โปรดลองอีกครั้งภายหลัง.",
		"invited_users": "และ {students} พนักงานถูกเชิญ!",
		"goals": {
			"engage_students": "สร้างการมีส่วนร่วมกับพนักงาน",
			"engage_review": "คุณสามารถชวนพนักงานของคุณให้ฝึกภาษาอังกฤษนี่คือสิ่งที่เราแนะนำให้เริ่ม:",
			"get_insight_about_students": "ดูข้อมูลทักษะภาษาอังกฤษปัจจุบันของพนักงาน"
		},
		"invite_students": "เชิญพนักงาน",
		"student_name": "ชื่อพนักงาน",
		"teachers_page": {
			"title": "หัวหน้าทีม",
			"invite": "เชิญหัวหน้าทีม",
			"table": {
				"number_of_students": "จำนวนพนักงาน",
				"number_of_classes": "จำนวนทีม"
			}
		},
		"students_page": {
			"title": "พนักงาน",
			"invite": "เชิญพนักงาน"
		},
		"select_teacher": "เลือกหัวหน้า",
		"add_new_teacher": "เพิ่มหัวหน้าทีมใหม่",
		"dashboard": {
			"class_overview": "ภาพรวมทีม",
			"view_class": "ดูทีม",
			"profile": "โปรไฟล์บริษัท",
			"add_student": "เชิญพนักงาน",
			"new_group": "สร้างทีมใหม่",
			"add_teacher": "เชิญหัวหน้า"
		},
		"teacher_info": {
			"show_list_of_classes": "แสดงรายการทีม",
			"show_list_of_students": "แสดงรายการพนักงาน",
			"classes_assigned_to": "ทีมถูกมอบหมายไปที่",
			"show_all_classes": "แสดงทีมทั้งหมด"
		},
		"classes": {
			"active_students": "พนักงานที่แอคทีฟ (ฝึกอย่างน้อยหนึ่งบทเรียน)",
			"import_users": "นำพนักงานเข้าสู่หลายทีม"
		},
		"students_improvement": "ความก้าวหน้าของทีม",
		"auto_enroll_message_confirm": "พนักงานจะถูกเพิ่มเข้าสู่ทีมอัตโนมัติ<br/>โดยเลือกตัวเลือกauto-enroll คุณต้องได้รับอนุญาตจากผู้เรียนล่วงหน้าในการเพิ่มเข้าสู่ชั้นเรียน/ทีม<br/>ต้องการดำเนินการต่อหรือไม่?",
		"accept_invitation_enroll_message_confirm": "พนักงานต้องตอบรับคำเชิญรายคนเพื่อเข้าสู่ทีม ต้องการดำเนินการต่อหรือไม่?",
		"pending_invites_teacher": "คำเชิญหัวหน้ารอการตอบรับ"
	},
	"school_labels": {
		"average_lessons": "จำนวนวันที่ฝึกต่อสัปดาห์",
		"all_users": "นักเรียนทั้งหมด",
		"groups": "ชั้นเรียน",
		"teachers": "ครู",
		"teacher": "ครู",
		"students": "นักเรียน",
		"student": "นักเรียน",
		"active_students": "นักเรียนที่แอคทีฟ",
		"remove_teacher_from_organization": "ลบหัวหน้าออกจากองค์กร",
		"remove_student_from_organization": "ลบนักเรียนออกจากองค์กร",
		"remove_student_from_group": "ลบนักเรียนออกจากชั้นเรียน",
		"all_teachers": "ครูทั้งหมด",
		"all_students": "นักเรียนทั้งหมด",
		"all_groups": "ชั้นเรียนทั้งหมด",
		"edit_group": "แก้ไขชั้นเรียน",
		"add_to_group_title": "เพิ่มห้องเรียน",
		"add_to_group": "ห้องเรียนใหม่",
		"import_class_success_title": "{numberClassesImported} ชั้นเรียนถูกสร้างสำเร็จ",
		"add_to_group_success": "ผู้ใช้ถูกเพิ่มเข้าสู่ชั้นเรียน",
		"add_to_group_warning": "ผู้ใช้ไม่สามารถถูกเพิ่มเข้าสู่ชั้นเรียน",
		"remove_from_class_success": "ผู้ใช้ถูกลบออกจากทีม",
		"remove_from_class_warning": "ไม่สามารถลบผู้ใช้ออกจากทีมได้",
		"assign_license_to_user_success": "มอบหมายใบอนุญาตให้ผู้ใช้เรียบร้อยแล้ว",
		"assign_license_to_user_warning": "มอบหมายใบอนุญาตให้ผู้ใช้ไม่สำเร็จ",
		"create_new_group": "สร้างชั้นเรียนใหม่",
		"no_groups_yet": "คุณยังไม่มีชั้นเรียน",
		"no_students_yet": "คุณยังไม่มีนักเรียน",
		"no_teachers_available": "ไม่มีครูให้เลือก",
		"create_group": "สร้างชั้นเรียน",
		"import_groups": "นำเข้าชั้นเรียน",
		"import_groups_success": "ชั้นเรียนถูกสร้าง",
		"import_users_to_groups_success": "นำนักเรียนเข้าสู่ชั้นเรียนสำเร็จ",
		"group_title": "ชื่อชั้นเรียน",
		"group_name": "ชื่อชั้นเรียน",
		"group_details": "รายละเอียดชั้นเรียน",
		"step_group_details": "{step}รายละเอียดชั้นเรียน",
		"select_teacher": "เลือกครู",
		"add_new_teacher": "เพิ่มครูใหม่",
		"upload_emails": "นำนักเรียนเข้าชั้นเรียน",
		"errors": {
			"please_provide_group_name": "โปรดระบุชื่อชั้นเรียน",
			"please_provide_teacher_name": "โปรดระบุชื่อครู"
		},
		"add_students": "เพิ่มนักเรียน",
		"group_overview": "ภาพรวมชั้นเรียน",
		"group_teacher": "ครูของชั้นเรียน",
		"will_be_added_students": "นักเรียน {numberOfUsers} คนจะถูกเพิ่มเข้าสู่ชั้นเรียนเมื่อคุณสร้างชั้นเรียน",
		"student_consent_to_class": "นักเรียน {numberOfUsers} คนจะถูกเพิ่มเข้าสู่ชั้นเรียนโดยอัตโนมัติ",
		"students_list": "รายชื่อนักเรียน",
		"your_group_was_created": "ชั้นเรียนถูกสร้าง,",
		"error_when_inviting": "แต่มีข้อผิดพลาดเมื่อเชิญนักเรียน โปรดลองอีกครั้งภายหลัง.",
		"invited_users": "และนักเรียน {students} คนถูกเชิญ!",
		"goals": {
			"engage_students": "สร้างการมีส่วนร่วมกับนักเรียน",
			"engage_review": "คุณสามารถชวนนักเรียนของคุณให้ฝึกภาษาอังกฤษนี่คือสิ่งที่เราแนะนำให้เริ่ม:",
			"get_insight_about_students": "ดูข้อมูลทักษะภาษาอังกฤษปัจจุบันของนักเรียน"
		},
		"invite_students": "เชิญนักเรียน",
		"student_name": "ชื่อนักเรียน",
		"teachers_page": {
			"title": "ครู",
			"invite": "เชิญครู",
			"table": {
				"number_of_students": "จำนวนนักเรียน",
				"number_of_classes": "จำนวนชั้นเรียน"
			}
		},
		"students_page": {
			"title": "นักเรียน",
			"invite": "เชิญนักเรียน"
		},
		"dashboard": {
			"class_overview": "ภาพรวมชั้นเรียน",
			"view_class": "ดูชั้นเรียน",
			"profile": "โปรไฟล์โรงเรียน",
			"add_student": "เชิญนักเรียน",
			"new_group": "สร้างชั้นเรียนใหม่",
			"add_teacher": "เชิญครู"
		},
		"teacher_info": {
			"show_list_of_classes": "แสดงรายการชั้นเรียน",
			"show_list_of_students": "แสดงรายการนักเรียน",
			"classes_assigned_to": "ชั้นเรียนถูกมอบหมายให้",
			"show_all_classes": "แสดงชั้นเรียนทั้งหมด"
		},
		"classes": {
			"active_students": "นักเรียนที่แอคทีฟ (ฝึกอย่างน้อยหนึ่งบทเรียน)",
			"import_users": "นำนักเรียนเข้าสู่หลายชั้นเรียน"
		},
		"students_improvement": "การพัฒนาของชั้นเรียน",
		"auto_enroll_message_confirm": "นักเรียนจะถูกเพิ่มเข้าสู่ชั้นเรียนโดยอัตโนมัติ <br/>โดยเลือกตัวเลือก auto-enroll, คุณต้องได้รับอนุญาตจากนักเรียนล่วงหน้าในการเพิ่มเข้าสู่ชั้นเรียน <br/><br/>คุณต้องการดำเนินการต่อหรือไม่?",
		"accept_invitation_enroll_message_confirm": "นักเรียนต้องตอบรับคำเชิญเป็นรายคนเพื่อเข้าสู่ชั้นเรียน <br/>ต้องการดำเนินการต่อหรือไม่?",
		"pending_invites_teacher": "คำเชิญครูที่รอการตอบรับ",
		"delete_user_from_class_message_confirm":"Khuṇ næ̀cı h̄rụ̄x mị̀ ẁā t̂xngkār nả nạkreīyn xxk",
	},
	"elsa_goals": {
		"goals": "ใช้แอปการออกเสียงชั้นนำเพื่อช่วยนักเรียนพัฒนาทักษะภาษาอังกฤษ:",
		"goal1": "จัดชั้นเรียนแบบยืดหยุ่น",
		"goal2": "ดูรายงานความก้าวหน้า",
		"goal3": "เชิญนักเรียนรายคนหรือรายกลุ่ม"
	},
	"navbar": {
		"dashboard": "แดชบอร์ด",
		"classes": "ชั้นเรียน",
		"teachers": "ครู",
		"students": "นักเรียน",
		"account": "บัญชี",
		"my_profile": "โปรไฟล์ของฉัน",
		"manage": "รายการองค์กร",
		"logout": "ออกจากระบบ",
		"hello": "สวัสดี",
		"organizations": "องค์กร",
		"org_current": "องค์กรปัจจุบัน",
		"Language": "Language"
	},
	"teacher_info": {
		"profile": "โปรไฟล์",
		"first_name": "ชื่อ",
		"last_name": "นามสกุล",
		"email": "อีเมล",
		"username": "ชื่อผู้ใช้งาน",
		"phone_number": "เบอร์โทรศัพท์",
		"user_roles": "ตำแหน่งผู้ใช้",
		"department": "แผนก",
		"title": "คำนำหน้า",
		"user_role": "ตำแหน่งผู้ใช้",
		"overview": "ภาพรวม"
	},
	"student_info": {
		"overview": "ภาพรวม",
		"profile": "โปรไฟล์"
	},
	"user_profile": {
		"title": "",
		"dont_belong_organization": "คุณไม่อยู่ในองค์กรใดเลย.",
		"join_organization": "เข้าร่วมองค์กร",
		"create_organization": "สร้างองค์กร",
		"withdraw_from_organization": "ถอนจากองค์กร",
		"your_profile": {
			"title": "โปรไฟล์ของคุณ",
			"first_name": "ชื่อ",
			"last_name": "นามสกุล",
			"user_name": "ชื่อผู้ใช้งาน",
			"email": "อีเมล",
			"not_verified": "ไม่ได้ตรวจสอบ",
			"phone_number": "เบอร์โทรศัพท์",
			"did_not_receive": "ไม่ได้รับอีเมลยืนยัน?",
			"resent_email": "ส่งอีเมลอีกครั้ง",
			"modals": {
				"edit_profile": {
					"update_success": "ผู้ใช้ถูกอัปเดตสำเร็จ",
					"title": "แก้ไขโปรไฟล์",
					"upload_image": {
						"label": "อัปโหลดภาพ"
					},
					"first_name": {
						"label": "ชื่อ",
						"placeholder": "ใส่ชื่อของคุณ"
					},
					"last_name": {
						"label": "นามสกุล",
						"placeholder": "ใส่นามสกุลของคุณ"
					},
					"email": {
						"label": "อีเมล",
						"placeholder": "ใส่ที่อยู่อีเมลของคุณ"
					},
					"user_name": {
						"label": "ชื่อผู้ใช้งาน",
						"placeholder": "ใส่ชื่อผู้ใช้งานของคุณ"
					},
					"phone": {
						"label": "เบอร์โทรศัพท์",
						"placeholder": "+1-000-000-0000"
					},
					"save": "บันทึก",
					"cancel": "ยกเลิก"
				},
				"confirm_new_email": {
					"title": "ยืนยันที่อยู่อีเมลของคุณ",
					"message": "เราส่งอีเมลยืนยันให้คุณ เช็คอีเมลของคุณและยืนยันอีเมลใหม่ของคุณ",
					"button_label": "ได้แล้ว!"
				}
			}
		},
		"change_password": {
			"title": "เปลี่ยนรหัสผ่าน",
			"password": "รหัสผ่าน",
			"modals": {
				"title": "เปลี่ยนรหัสผ่าน",
				"current_password": {
					"label": "รหัสผ่านปัจจุบัน",
					"placeholder": "ใส่รหัสผ่านปัจจุบัน"
				},
				"new_password": {
					"label": "รหัสผ่านใหม่",
					"placeholder": "ใส่รหัสผ่านใหม่"
				},
				"confirm_new_password": {
					"label": "ใส่รหัสผ่านใหม่อีกครั้ง",
					"placeholder": "ใส่รหัสผ่านใหม่อีกครั้ง"
				},
				"save": "บันทึก",
				"cancel": "ยกเลิก",
				"change_pass_elsa": "โปรดใช้แอป ELSA ในการเปลี่ยนรหัสผ่าน"
			}
		},
		"your_organizations": {
			"title": "องค์กรของคุณ",
			"modals": {
				"title": "ถอนจาก {name}",
				"admin": {
					"message_1": "คุณแน่ใจว่าต้องการถอนจาก {name}?",
					"message_2": "คุณคือแอดมินคนเดียวของ {name}. ถ้าต้องการถอนออกจากองค์กร โปรดเชิญคนอื่นมาเป็นเจ้าของบัญชี."
				},
				"teacher": {
					"message_1": "คุณแน่ใจหรือไม่ว่าต้องการถอนจาก {name}? คุณจะหมดสิทธิ์การเข้าถึง pro license ปัจจุบัน ",
					"message_2": "คุณคือครูที่ได้รับมอบหมายของ {numberOfClasses} ชั้นเรียนในกรณีที่ต้องการถอนออกจากองค์กร โปรดติดต่อแอดมินองค์กรเพื่อลบคุณออกจากบทบาทนั้น"
				},
				"student": {
					"message_1": "หากคุณถอน คุณต้องได้รับคำเชิญเพื่อเข้าร่วม {name} อีกครั้ง",
					"message_2": "คุณแน่ใจหรือไม่ว่าต้องการถอนจาก {name}? คุณจะหมดสิทธิ์การเข้าถึง pro license ปัจจุบัน"
				},
				"confirm": "ใช่, ต้องการถอน",
				"cancel": "ไม่, ยกเลิก",
				"got_it": "ได้แล้ว!"
			}
		},
		"social": {
			"title": "โซเชียล",
			"modals": {
				"title": "ใส่รหัสผ่าน",
				"subtitle": "ใส่รหัสผ่านเพื่อคุณจะสามารถเข้าถึงบัญชีโดยไม่ต้องใช้ Facebook",
				"password": {
					"label": "รหัสผ่าน",
					"placeholder": "ใส่รหัสผ่านใหม่"
				},
				"repeat_password": {
					"label": "ใส่รหัสผ่านใหม่อีกครั้ง",
					"placeholder": "ใส่รหัสผ่านใหม่อีกครั้ง"
				},
				"save": "บันทึก",
				"cancel": "ยกเลิก"
			}
		},
		"delete_account": {
			"button": "ลบบัญชี",
			"modals": {
				"title": "ลบบัญชี",
				"warning": "คุณแน่ใจว่าคุณต้องการถอนจาก {organizationName}? ถ้าอย่างนั้นโปรดกรอกข้อมูลต่อไปนี้:",
				"terms_and_conditions": "ฉันเข้าใจว่าฉันจะสูญเสียการเข้าถึงข้อมูลการใช้งานและ license ปัจจุบันของฉัน",
				"password": "รหัสผ่าน",
				"delete_account": "ลบบัญชี",
				"cancel": "ยกเลิก"
			}
		}
	},
	"login": {
		"title": "เข้าสู่ระบบด้วยบัญชี ELSA ของคุณ",
		"accept_invitation": "เข้าสู่ระบบบัญชี ELSA ของคุณเพื่อตอบรับคำเชิญจาก {organizationName}.",
		"email_field": {
			"label": "อีเมล",
			"placeholder": "กรอกที่อยู่อีเมล"
		},
		"password_field": {
			"label": "รหัสผ่าน",
			"placeholder": "ใส่รหัสผ่าน"
		},
		"forgot_password": "ลืมรหัสผ่านของคุณ?",
		"login_and_accept_invitation": "เข้าสู่ระบบและตอบรับคำเชิญ",
		"dont_have_account": "ไม่มีบัญชีผู้ใช้?",
		"create_account": "สร้างบัญชี",
		"login": "เข้าสู่ระบบ",
		"invalid_token": "คำเชิญหมดอายุหรือใช้การไม่ได้"
	},
	"confirm_account": {
		"title": "ยืนยันบัญชีของคุณ",
		"check_inbox": "เราเพิ่งส่งอีเมลยืนยันให้คุณ ตรวจสอบอีเมลและยืนยันบัญชีของคุณ",
		"didnt_receive": "ยังไม่ได้รับ?",
		"resend_confirmation": "ส่งอีเมลยืนยันอีกครั้ง",
		"got_it": "ได้รับแล้ว!"
	},
	"resend_confirmation": {
		"title": "ส่งอีเมลยืนยันอีกครั้ง",
		"send_confirmation": "เราจะส่งอีเมลยืนยันให้คุณใหม่ โปรดตรวจสอบว่าที่อยู่อีเมลของคุณถูกต้อง",
		"email_field": {
			"label": "อีเมล",
			"placeholder": "ใส่อีเมล"
		},
		"resend_email": "ส่งอีเมลใหม่"
	},
	"recover_password": {
		"title": "กู้คืนรหัสผ่าน",
		"enter_email_to_reset": "ใส่ที่อยู่อีเมลของคุณเพื่อเราจะได้รีเซ็ตรหัสผ่านให้คุณ",
		"reset_pass_elsa": "โปรดใช้ ELSA App เพื่อรีเซ็ตรหัสผ่าน",
		"email_field": {
			"label": "ที่อยู่อีเมล",
			"placeholder": "ใส่ที่อยู่อีเมล"
		},
		"reset_password": "รีเซ็ตรหัสผ่าน",
		"sent_email_check_inbox": "เราส่งอีเมลให้คุณแล้ว ตรวจสอบอีเมลของคุณและรีเซ็ตรหัสผ่าน",
		"got_it": "ได้รับแล้ว!"
	},
	"reset_password_modal": {
		"title": "รีเซ็ตรหัสผ่าน",
		"enter_your_password": "ใส่รหัสผ่านใหม่",
		"button_text": "รีเซ็ตรหัสผ่าน",
		"new_password_field": {
			"label": "รหัสผ่านใหม่",
			"placeholder": "ใส่รหัสผ่านใหม่"
		},
		"confirm_password_field": {
			"label": "คอนเฟิร์มรหัสผ่านใหม่",
			"placeholder": "ใส่รหัสผ่านใหม่"
		}
	},
	"sign_up": {
		"title": "สร้างบัญชี ELSA",
		"sign_up": "ลงทะเบียน",
		"first_name_field": {
			"label": "ชื่อ",
			"placeholder": "ใส่ชื่อ"
		},
		"last_name_field": {
			"label": "นามสกุล",
			"placeholder": "ใส่นามสกุล"
		},
		"email_field": {
			"label": "ที่อยู่อีเมล",
			"placeholder": "ใส่ที่อยู่อีเมล"
		},
		"password_field": {
			"label": "รหัสผ่าน",
			"placeholder": "ใส่รหัสผ่าน"
		},
		"signup_accept_invitation": "ลงทะเบียนและตอบรับคำเชิญ",
		"invitation_code": "คุณมีโค้ดเชิญหรือไม่?",
		"tooltip_message": "ถ้าคุณมีโค้ดเชิญ กรอกที่นี่",
		"by_signing_up_to_elsa": "ด้วยการลงทะเบียนกับ ELSA, คุณเห็นด้วยกับ ",
		"already_have_an_account": "มีบัญชีอยู่แล้ว?"
	},
	"verify_facebook_info_modal": {
		"title": "ตรวจสอบข้อมูลของคุณ",
		"save_continue": "บันทึกและไปต่อ",
		"first_name_field": {
			"label": "ชื่อ",
			"placeholder": "ชื่อ"
		},
		"last_name_field": {
			"label": "นามสกุล",
			"placeholder": "นามสกุล"
		},
		"email_field": {
			"label": "ที่อยู่อีเมล",
			"placeholder": "ใส่ที่อยู่อีเมล"
		}
	},
	"organizations": {
		"groups": "กลุ่ม",
		"users": "ผู้ใช้งาน",
		"table": {
			"user_email": "ที่อยู่อีเมล",
			"username": "ชื่อ",
			"titleDept": "คำนำหน้า / แผนก.",
			"roles": "ตำแหน่ง",
			"actions": "การกระทำ",
			"empty": "ไม่พบผู้ใช้งาน",
			"empty_admin": "ไม่พบแอดมิน",
			"empty_student": "ไม่พบนักเรียน",
			"empty_teacher": "ไม่พบครู"
		},
		"users_section": {
			"invite_users": "เชิญผู้ใช้งาน",
			"invite_by_email": "เชิญด้วยอีเมล",
			"import_users": "นำผู้ใช้งานเข้าสู่หลายกลุ่ม",
			"import_elsa_id": "นำ Elsa_Id เข้าสู่หลายกลุ่ม",
			"share_code": "รับโค้ด",
			"share_link": "แชร์ลิงก์",
			"share_qr_code": "แชร์ QR code",
			"add_to_group": "เพิ่มเข้าสู่กลุ่ม",
			"add_to_class": "เพิ่มเข้าสู่คลาส",
			"revoke_license": "ถอน license",
			"enable_license": "เปิดใช้ license",
			"disable": "ยกเลิกใช้งาน",
			"delete": "ลบ",
			"no_users": "เชิญผู้ใช้งานเข้าร่วมองค์กรของคุณ:",
			"no_users_1": "คุณยังไม่ผู้ใช้งาน.",
			"no_users_2": "เพิ่มผู้ใช้งานหรือแชร์องค์กรของคุณ.",
			"select_role": "เลือกบทบาท",
			"user_profile": {
				"user_details": {
					"title": "รายละเอียดผู้ใช้งาน"
				},
				"user_roles": {
					"title": "บทบาทผู้ใช้งาน"
				}
			},
			"enable_license_message": "Pro License ถูกออกให้ {firstName} {lastName}",
			"modals": {
				"share_qr_code": {
					"title": "แชร์ QR code",
					"print_code": "พิมพ์ QR code",
					"share_with_users": "แชร์กับผู้ใช้งานเพื่อแสกนและเข้าสู่องค์กรของคุณ.",
					"print": "พิมพ์",
					"no_cancel": "แคนเซิล"
				},
				"share_link": {
					"title": "แชร์ลิงก์",
					"copy_link": "คัดลอกลิงก์",
					"got_it": "ได้รับแล้ว!",
					"cancel": "ยกเลิก"
				},
				"share_code": {
					"title": "รับโค้ด",
					"share_the_following_code": "สร้างโค้ด",
					"user_can_join": "แชร์โค้ดกับผู้ใช้งานเพื่อแสกนเข้าร่วมองค์กรของคุณ.",
					"generate_code": "สร้างโค้ด",
					"done": "สำเร็จ"
				},
				"invite_users": {
					"copy_and_paste": "คัดลอกและวางที่อยู่อีเมล",
					"title": "ส่งอีเมลเชิญ",
					"select_role_placeholder": "เลือกบทบาทผู้ใช้งาน",
					"select_role_label": "บทบาทผู้ใช้งาน  ",
					"copy_paste_emails": "คัดลอกและวางที่อยู่อีเมล",
					"invite_users": "เชิญผู้ใช้งาน",
					"add_email": "ใส่ที่อยู่อีเมลหลายอัน (แยกด้วยคอมม่า)",
					"success": "ผู้ใช้งานถูกเพิ่มเข้าสู่รายการผู้ใช้งาน",
					"consent": "ยินยอม",
					"consent1": "เพิ่มผู้ใช้งานอัตโนมัติเข้าสู่ {organizationName}"
				},
				"edit_user": {
					"update_success": "การอัปเดตสำเร็จ",
					"title": "แก้ไขบทบาทผู้ใช้งาน",
					"user_title": "เลือกคำนำหน้า",
					"user_title_placeholder": "คำนำหน้า",
					"department": "เลือกแผนก",
					"department_placeholder": "แผนก"
				},
				"disable": {
					"title": "ถอน {numberOfAccounts} บัญชีผู้ใช้งาน",
					"message": "คุณแน่ใจว่าต้องการถอน pro licenses สำหรับ {numberOfAccounts} ผู้ใช้งาน?",
					"confirm": "ใช่, ถอน",
					"cancel": "ไม่, ยกเลิก"
				},
				"delete": {
					"title": "ลบผู้ใช้งานออกจากองค์กร",
					"message": "คุณแน่ใจว่าต้องการลบ {numberOfAccounts} ผู้ใช้งานออกจากองค์กร?",
					"confirm": "ใช่, ลบ",
					"cancel": "ไม่, ยกเลิก"
				},
				"delete_from_class": {
					"title": "ลบผู้ใช้ออกจากทีม",
					"message": "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ใช้ {numberOfAccounts} รายออกจากทีมของคุณ",
					"confirm": "ใช่, ลบ",
					"cancel": "ไม่, ยกเลิก"
				}
			},
			"popovers": {
				"groups": {
					"title": "เพิ่มเข้าสู่กลุ่ม",
					"add_group": "เพิ่มกลุ่ม",
					"manage_groups": "จัดการกลุ่ม"
				},
				"classes": {
					"title": "เพิ่มเข้าสู่ชั้นเรียน",
					"new_class": "ชั้นเรียนใหม่"
				},
				"roles": {
					"title": "แก้ไขบทบาท"
				}
			}
		},
		"invite_users": {
			"title": "เชิญผู้ใช้งาน",
			"subtitle": "เชิญผู้ใช้งานร่วมองค์กรของคุณ:",
			"import_users": "นำเข้ารายชื่อที่อยู่อีเมลเข้าสู่กลุ่มที่เลือก",
			"import_users_classes": "นำเข้ารายชื่อที่อยู่อีเมลเข้าสู่หลาย",
			"share_link": "แชร์ลิงก์",
			"mail_invite": "คัดลอกและวางที่อยู่อีเมล",
			"multiple_mail_invite_with_enrolled": "{numberOfInvites} ผู้ใช้งานถูกเพิ่มเข้าสู่กลุ่ม",
			"multiple_mail_invite": "{numberOfInvites} ผู้ใช้งานถูกเชิญ",
			"multiple_mail_to_invite": "{numberOfInvites} ผู้ใช้งานถูกเชิญ",
			"import": {
				"elsa-title": "นำเข้ารายชื่อ ID ผู้ใช้งาน Elsa",
				"title": "นำเข้ารายชื่อที่อยู่อีเมล",
				"subtitle": "นำเข้ารายชื่อ",
				"instructions": "ลากและปล่อยไฟล์ของคุณที่นี่เพื่ออัปโหลด",
				"files": "{fileCount} ไฟล์ถูกอัปโหลด",
				"instructions2": "ดาวน์โหลดเทมเพลต",
				"instructions3": "กรอกและลากเพื่อนำข้อมูลเข้า",
				"get_template": "รับเทมเพลต",
				"get_template_xlsx": "รูปแบบ MS",
				"get_template_csv": "รูปแบบ CSV",
				"browse_files": "เลือกไฟล์"
			},
			"link": {

			},
			"mail": {
				"title": "คัดลอกและวางที่อยู่อีเมล"
			},
			"confirmation_title": "การยืนยัน"
		}
	},
	"table_row": {
		"actions": {
			"remove_from_group": "ลบออกจากกลุ่ม",
			"add_to_class": "เพิ่มเข้าสู่ชั้นเรียน",
			"disable": "ยกเลิกการใช้งาน",
			"delete": "ลบ"
		}
	},
	"organization_profile": {
		"title": "โปรไฟล์",
		"admins": "แอดมิน",
		"invite_another_admin": "เชิญแอดมินเพิ่ม",
		"pending_request": "คำขอที่รอการตอบรับ",
		"organization_name": "ชื่อองค์กร",
		"organization_username": "ชื่อผู้ใช้งานองค์กร",
		"organization_type_industry": "ประเภท/ธุรกิจ องค์กร",
		"phone": "หมายเลขโทรศัพท์",
		"address": "ที่อยู่",
		"affiliate": "สาขา",
		"admin_actions": {
			"remove_from_admin": "ลบ",
			"edit_user": "แก้ไขผู้ใช้งาน",
			"remove_from_organization": "ลบออกจากองค์กร",
			"user_id_only_admin": "ไม่สามารถลบแอดมินเพียงคนเดียวขององค์กร"
		},
		"remove_admin_modal": {
			"title": "ลบแอดมิน",
			"yes_remove": "ใช่, ลบ",
			"no_cancel": "ไม่, ยกเลิก"
		},
		"invite_admin_modal": {
			"invite_success": "คำเชิญถูกส่งแล้ว",
			"remove_invite_success": "ลบคำเชิญสำเร็จแล้ว",
			"remove_invite_fail": "ลบคำเชิญไม่สำเร็จ",
			"confirm_remove_invitation": "คุณต้องการลบคำเชิญนี้หรือไม่?",
			"title": "เชิญแอดมินใหม่",
			"email_field": {
				"label": "ที่อยู่อีเมล",
				"placeholder": "ใส่ที่อยู่อีเมล"
			},
			"invite_button": "เชิญ",
			"cancel_button": "ยกเลิก"
		},
		"delete_disable_organization_modal": {
			"title_delete": "ลบ",
			"title_disable": "ยกเลิกการใช้งาน",
			"title_enable": "เปิดการใช้งาน",
			"password_field": {
				"label": "รหัสผ่าน",
				"placeholder": "ใส่รหัสผ่าน"
			},
			"delete_button": "ลบองค์กร",
			"disable_button": "ใช่, ยกเลิกการใช้งาน",
			"enable_button": "ใช้, เปิดการใช้งาน",
			"cancel_button": "ยกเลิก",
			"delete_terms": "ฉันเข้าใจว่าฉันจะสูญเสียข้อมูลการใช้งานและ licenses ปัจจุบันของฉัน",
			"disable_terms": "ฉันเข้าใจว่าผู้ใช้งานจะสูญเสีย licenses ที่จ่ายเงินแล้ว",
			"are_you_sure_disable": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการใช้งาน",
			"are_you_sure_enable": "คุณแน่ใจหรือไม่ว่าต้องการเปิดการใช้งาน",
			"are_you_sure_widthraw": "คุณแน่ใจหรือไม่ว่าต้องการถอนจาก",
			"if_so_fill_following": "ถ้าเช่นนั้น โปรดกรอกข้อมูลต่อไปนี้:"
		},
		"edit_organization_modal": {
			"invite_not_send": "องค์กรถูกสร้างแล้วแต่ไม่สามารถส่งคำเชิญได้",
			"update_success": "องค์กรถูกอัปเดต",
			"create_success": "องค์กรถูกสร้าง",
			"create_title": "สร้างองค์กรใหม่",
			"edit_title": "แก้ไของค์กร",
			"save": "บันทึก",
			"cancel": "ยกเลิก",
			"upload_logo_field": {
				"label": "อัปโหลดโลโก้"
			},
			"verified_organization": "ยืนยันองค์กร",
			"enable_organization": "เปิดใช้งานองค์กร",
			"disable_organization": "ยกเลิกการใช้งานองค์กร",
			"delete_organization": "ลบองค์กร",
			"are_you_sure_disable": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการใช้งาน",
			"name_field": {
				"label": "ชื่อองค์กร",
				"placeholder": "ใส่ชื่อองค์กร"
			},
			"username_field": {
				"label": "ชื่อผู้ใช้งาน",
				"placeholder": "ใส่ชื่อผู้ใช้งานองค์กร"
			},
			"org_type_field": {
				"label": "ประเภทองค์กร",
				"placeholder": "เลือกประเภทองค์กร"
			},
			"industry_field": {
				"label": "ธุรกิจ",
				"placeholder": "เลือกธุรกิจ"
			},
			"address_field": {
				"label": "ที่อยู่",
				"placeholder": "ใส่ที่อยู่องค์กร"
			},
			"phone_field": {
				"label": "เบอร์โทรศัพท์",
				"placeholder": "+1-000-000-0000"
			},
			"country_field": {
				"label": "ประเทศ",
				"placeholder": "ใส่ประเทศ"
			},
			"state_field": {
				"label": "รัฐ/จังหวัด",
				"placeholder": "ใส่รัฐ/จังหวัด"
			},
			"city_field": {
				"label": "เมือง",
				"placeholder": "ใส่เมือง"
			},
			"post_code_field": {
				"label": "รหัสไปรษณีย์",
				"placeholder": "รหัสไปรษณีย์"
			},
			"owner_field": {
				"label": "เจ้าของบัญชี",
				"placeholder": "เจ้าของ"
			},
			"affiliate_field": {
				"label": "สาขา",
				"placeholder": "ไม่มี"
			},
			"timezone_field": {
				"label": "ไทม์โซน",
				"placeholder": "Etc/GMT"
			}
		}
	},
	"admin": {
		"organizations": {
			"title": "องค์กร",
			"create_new_organization": "สร้างองค์กรใหม่",
			"import_organizations": "นำเข้าองค์กร",
			"verify": "ตรวจสอบ",
			"table": {
				"verification": "การตรวจสอบ",
				"not_verified": "ยังไม่ได้ตรวจสอบ",
				"verified": "ตรวจสอบแล้ว",
				"organization_name": "ชื่อองค์กร",
				"status": "สถานะ",
				"licences": "Licenses",
				"empty": "ไม่พบองค์กร",
				"active": "แอคทีฟ",
				"inactive": "ถูกยกเลิกการใช้งาน",
				"affiliate": "สาขา",
				"created_at": "วันที่สร้าง"
			},
			"filter_menu": {
				"all": "ทั้งหมด",
				"active": "แอคทีฟ",
				"disabled": "ยกเลิกการใช้งานแล้ว",
				"verified": "ตรวจสอบแล้ว"
			}
		}
	},
	"organization_page": {
		"organizations": "องค์กร",
		"disable": "ยกเลิกการใช้งาน",
		"delete": "ลบ",
		"menu": {
			"licences": "Licenses",
			"users": {
				"title": "ผู้ใช้งาน",
				"all_users": "ผู้ใช้งานทั้งหมด",
				"employees": "พนักงาน",
				"leads": "หัวหน้าทีม",
				"admins": "แอดมิน"
			},
			"groups": "กลุ่ม",
			"profile": "โปรไฟล์"
		}
	},
	"disable_organization_modal": {
		"title": "ยกเลิกการใช้งาน",
		"yes_disable": "ใช่, ยกเลิกการใช้งาน",
		"no_cancel": "ไม่, ยกเลิก"
	},
	"onboarding": {
		"welcome": "ขอต้อนรับสู่ ELSA",
		"welcome_subtitle": "บอกเราสักหน่อยเกี่ยวกับคุณ เราจะได้สามารถแนะนำ ELSA journey ให้คุณได้",
		"who_are_you": "คุณคือใคร?",
		"select_option": "เลือกหนึ่งตัวเลือกด้านล่าง",
		"school": "โรงเรียน",
		"school_admin": "แอดมินโรงเรียน",
		"company": "บริษัท",
		"company_admin": "แอดมินบริษัท",
		"teacher": "ครู",
		"student": "นักเรียน",
		"continue": "ไปต่อ"
	},
	"school": {
		"setup_school": {
			"successfully_created": "โรงเรียนของคุณถูกสร้างสำเร็จ",
			"setup_your_school": "ติดตั้งโรงเรียนของคุณ",
			"invite_students_teachers": "เชิญนักเรียนและครูเข้าร่วมองค์กร.",
			"create_your_first_class": "สร้างชั้นเรียนแรกของคุณ!",
			"create_class": "สร้างชั้นเรียน",
			"invite_teachers": "เชิญครู",
			"invite_students": "เชิญนักเรียน",
			"teacher": "ครู",
			"continue": "ไปต่อ"
		},
		"create_edit_modal": {
			"title": "สร้างโรงเรียน",
			"create": "สร้าง",
			"cancel": "ยกเลิก",
			"name_field": {
				"label": "ชื่อโรงเรียน",
				"placeholder": "ใส่ชื่อโรงเรียน"
			},
			"username_fields": {
				"label": "ชื่อผู้ใช้งาน",
				"placeholder": "ใส่ชื่อผู้ใช้งานโรงเรียน"
			},
			"type_field": {
				"label": "ประเภทโรงเรียน",
				"placeholder": "เลือกประเภทโรงเรียน"
			},
			"industry_field": {
				"label": "ธุรกิจ",
				"placeholder": "เลือกธุรกิจ"
			},
			"address_field": {
				"label": "ที่อยู่",
				"placeholder": "เลือกที่อยู่โรงเรียน"
			},
			"phone_field": {
				"label": "เบอร์โทรศัพท์",
				"placeholder": "+1-000-000-0000",
				"code": "โค้ด"
			},
			"country_field": {
				"label": "ประเทศ",
				"placeholder": "ใส่ประเทศ"
			},
			"state_field": {
				"label": "รัฐ/จังหวัด",
				"placeholder": "ใส่รัฐ/จังหวัด"
			},
			"city_field": {
				"label": "เมือง",
				"placeholder": "ใส่เมือง"
			},
			"post_code_field": {
				"label": "รหัสไปรษณีย์",
				"placeholder": "0000-00"
			}
		}
	},
	"company": {
		"setup_company": {
			"successfully_created": "บริษัทถูกสร้างสำเร็จ.",
			"setup_your_company": "ติดตั้งบริษัท",
			"invite_students_teachers": "เชิญนักเรียนและครูเข้าร่วมโรงเรียน",
			"create_class": "สร้างชั้นเรียน",
			"invite_teachers": "เชิญครู",
			"invite_students": "เชิญนักเรียน",
			"continue": "ไปต่อ"
		},
		"create_edit_modal": {
			"title": "สร้างบริษัท",
			"create": "สร้าง",
			"cancel": "ยกเลิก",
			"name_field": {
				"label": "ชื่อบริษัท",
				"placeholder": "ใส่ชื่อบริษัท"
			},
			"username_field": {
				"label": "ชื่อผู้ใช้งานบริษัท",
				"placeholder": "ใส่ชื่อผู้ใช้งานบริษัท"
			},
			"type_field": {
				"label": "ประเภทบริษัท",
				"placeholder": "ใส่ประเภทบริษัท"
			},
			"industry_field": {
				"label": "ประเภทธุรกิจ",
				"placeholder": "ใส่ธุรกิจ"
			},
			"address_field": {
				"label": "ที่อยู่",
				"placeholder": "ใส่ที่อยู่โรงเรียน"
			},
			"phone_field": {
				"label": "เบอร์โทรศัพท์",
				"placeholder": "+1-000-000-0000",
				"code": "โค้ด"
			},
			"country_field": {
				"label": "ประเทศ",
				"placeholder": "ใส่ประเทศ"
			},
			"state_field": {
				"label": "รัฐ/จังหวัด",
				"placeholder": "ใส่รัฐ/จังหวัด"
			},
			"city_field": {
				"label": "เมือง",
				"placeholder": "ใส่เมือง"
			},
			"post_code_field": {
				"label": "รหัสไปรษณีย์",
				"placeholder": "0000-00"
			}
		}
	},
	"teacher": {
		"are_you_part_of_organization": "คุณเป็นส่วนหนึ่งขององค์กรหรือไม่?",
		"select_one_options": "เลือกตัวเลือกด้านล่าง",
		"yes": "ใช่",
		"no": "ไม่",
		"teach_myself": "ฉันสอนด้วยตัวเอง",
		"continue": "ไปต่อ",
		"do_you_have_invitation_code": "คุณมีโค้ดเชิญหรือไม่?"
	},
	"student": {
		"are_you_part_of_organization": "คุณเป็นส่วนหนึ่งขององค์กรหรือไม่?",
		"select_one_options": "เลือกตัวเลือกด้านล่าง",
		"yes": "ใช่",
		"no": "ไม่",
		"learning_myself": "ฉันเรียนด้วยตนเอง",
		"continue": "ไปต่อ",
		"do_you_have_invitation_code": "คุณมีโค้ดเชิญหรือไม่?"
	},
	"setup_organization": {
		"join_your_organization": "เข้าร่วมองค์กรของคุณ",
		"wait_for_admin": "รอให้แอดมินส่งคำเชิญหรือกรอกโค้ดคำเชิญ",
		"enter_invitation_code": "ใส่โค้ดคำเชิญ",
		"continue": "ไปต่อ",
		"welcome_to_organization": "ขอต้อนรับสู่องค์กร A",
		"you_can_create_own_class": "คุณสามารถสร้างชั้นเรียนเองหรือรอให้แอดมินมอบหมายชั้นเรียนให้",
		"create_class": "Create class"
	},
	"start_learning": {
		"start_learning": "เริ่มเรียน",
		"download_elsa_app": "ดาวน์โหลดแอป ELSA Speak ใส่โทรศพท์มือถือ:",
		"or_send_the_email_by_link_sms": "หรือรับลิงก์ดาวน์โหลดผ่านอีเมลหรือ SMS มือถือ:",
		"send_email_link": "ส่งลิงก์ให้ฉันทางอีเมล",
		"send_sms_link": "ส่งลิงก์ให้ฉันทาง SMS",
		"start_practice": "เริ่มฝึก",
		"you_can_download": "คุณสามารถดาวน์โหลดแอปและเริ่มฝึก:",
		"to_join_our_organization": "เข้าร่วมองค์กรโดยรอให้แอดมินส่งคำเชิญหรือกรอกโค้ดคำเชิญ",
		"enter_invitation_code": "กรอกโค้ดคำเชิญ",
		"email_link_sent": "ลิงก์ถูกส่งให้ทางอีเมล",
		"sms_link_sent": "ลิงก์ถูกส่งให้ทาง SMS",
		"get_email_link_modal": {
			"title": "รับลิงก์ทางอีเมล",
			"get_email_link": "รับลิงก์ทางอีเมล",
			"email_field": {
				"label": "อีเมล",
				"placeholder": "กรอกที่อยู่อีเมล"
			},
			"phone_type_field": {
				"label": "ประเภทโทรศัพท์",
				"placeholder": "ประเภทโทรศัพท์"
			},
			"success": "อีเมลถูกส่งแล้ว",
			"warning": "ไม่สามารถส่งอีเมลได้ ลองใหม่อีกครั้ง"
		},
		"send_sms_link_modal": {
			"title": "รับลิงก์ทาง SMS",
			"get_sms_link": "รับลิงก์ทาง SMS ",
			"phone_type_field": {
				"label": "ประเภทโทรศัพท์",
				"placeholder": "ประเภทโทรศัพท์"
			},
			"phone_field": {
				"label": "โทรศัพท์",
				"placeholder": "+1-000-000-0000",
				"code": "โค้ด"
			},
			"success": "SMS ถูกส่งแล้ว",
			"warning": "SMS ไม่สามารถส่งได้ ลองอีกครั้งภายหลัง"
		}
	},
	"industries": {
		"aerospace": "อวกาศ",
		"transportation": "ขนส่ง",
		"computer_software_internet": "คอมพิวเตอร์ซอฟต์แวร์และอินเตอร์เน็ต",
		"telecommunication": "โทรคมนาคม",
		"food_and_agriculture": "อาหารและเกษตร",
		"construction": "ก่อสร้าง",
		"education": "การศึกษา",
		"healthcare": "สุขภาพ",
		"travel_and_hospitality": "การท่องเที่ยวและโรงแรม",
		"entertainment_news_media_music": "บันเทิง ข่าวและสื่อ",
		"energy": "พลังงาน",
		"manufacturing": "การผลิต",
		"fashion_and_clothing": "แฟชั่นและเสื้อผ้า",
		"mining": "เหมืองแร่",
		"consulting_services": "ที่ปรึกษา/บริการ",
		"other": "อื่นๆ"
	},
	"classes": {
		"accepted_users": "ผู้ใช้งานได้รับการยอมรับ",
		"pending_users": "ผู้ใช้งานรอการยอมรับ",
		"success_class_updated": "ชั้นเรียนถูกอัปเดตสำเร็จ",
		"success_remove_user":"ลบผู้ใช้ออกจากคลาสสำเร็จ",
		"reports": "รายงาน",
		"filter_menu": {
			"all": "ทั้งหมด",
			"active": "แอคทีฟ",
			"not_started": "ยังไม่เริ่ม",
			"draft": "ร่าง",
			"finished": "สำเร็จ"
		},
		"table_titles": {
			"start_date": "วันที่เริ่มต้น",
			"end_date": "วันที่สิ้นสุด",
			"status": "สถานะ"
		},
		"classes_details": {
			"left": " ออก",
			"to_go": " to go",
			"edit_class_name": "แก้ไข {name}",
			"menu": {
				"overview": "ภาพรวม",
				"detailed_progress": "รายละเอียดความก้าวหน้า",
				"time_tracking": "การติดตามเวลา"
			},
			"overview_section": {
				"title": "ภาพรวม",
				"students": "นักเรียน",
				"view_list": "ดูรายการ",
				"goals": "เป้าหมาย",
				"no_goals_set": "ไม่มีเป้าหมายถูกตั้งสำหรับชั้นเรียนนี้.",
				"minutes_per_day": "นาทีต่อวัน",
				"days_practice_per_week": "วันที่ฝึกต่อสัปดาห์",
				"set_goals": "ตั้งเป้าหมาย",
				"assessment_test_results": "ผลการประเมิน",
				"average_score": "คะแนนเฉลี่ย",
				"test_before_class_stats": "ทำแบบประเมินภายในกี่วัน"
			},
			"students_section": {
				"title": "นักเรียน",
				"pro_licence": "Pro License",
				"assessment_test": "คะแนนประเมิน",
				"date_take_assessment": "วันที่ประเมิน",
				"last_active_practice": "เวลาที่ฝึกล่าสุด",
				"practice_days_week": "จำนวนวันที่ฝึกต่อสัปดาห์",
				"min_spent": "นาทีที่ใช้",
				"last_eps": "คะแนน EPS ล่าสุด",
				"avg_daily_use": "การใช้เฉลี่ยต่อวัน (นาที)",
				"copy_paste_emails": "คัดลอกและวางที่อยู่อีเมล",
				"module_name": "ชื่อโมดูล",
				"lesson_name": "ชื่อบทเรียน",
				"lesson_EPS": "บทเรียน EPS",
				"lesson_take_date": "วันที่เข้าบทเรียน",
				"difficulty_level": "ระดับความยาก"
			},
			"activity_reports": {
				"title": "รายงานกิจกรรม",
				"lessons_overview": "ภาพรวมบทเรียน",
				"number_of_lessons_practiced": "จำนวนบทเรียนและนาทีที่ฝึก",
				"average_practice": "จำนวนเวลาที่ฝึกต่อวัน (นาที)",
				"progress": "ชาร์ตความก้าวหน้า (EPS เฉลี่ย)",
				"progress_student": "ชาร์ตความก้าวหน้า (EPS)",
				"0_5_percent": "0% - 5%",
				"6_10_percent": "6% - 10%",
				"11_50_percent": "11% - 50%",
				"51_70_percent": "51% - 70%",
				"mt_70_percent": "มากกว่า 70%"
			}
		},
		"create_class_flow": {
			"save_finish_later": "บันทึกและทำให้เสร็จภายหลัง",
			"cancel": "ยกเลิก",
			"save": "บันทึก",
			"next": "ถัดไป",
			"previous": "ก่อนหน้า",
			"details": "รายละเอียด",
			"list_students_modal": {
				"got_it": "ได้รับแล้ว!",
				"warning_no_student": "ไม่มีนักเรียนได้รับคำเชิญ"
			},
			"class_details": {
				"start_end_date": "วันที่เริ่มและสิ้นสุด"
			},
			"add_students": {
				"copy_paste_emails": "คัดลอกและวางที่อยู่อีเมล",
				"insert_multiple_emails": "ใส่อีเมลหลายอัน(แยกโดยคอมม่า)"
			},
			"class_overview": {
				"details": "รายละเอียด",
				"start_end_date": "วันที่เริ่มและสิ้นสุด",
				"not_selected": "ไม่ได้เลือก",
				"create_and_send_invites": "สร้างและส่งคำเชิญ"
			},
			"class_created": {
				"goals_section": {
					"practice_at_least": "ฝึกอย่างน้อย",
					"days_week": "วันต่อสัปดาห์.",
					"keep_them_engaged": "สร้างการมีส่วนร่วมกับพวกเขารายสัปดาห์",
					"practice": "ฝึก",
					"minutes_day": "นาทีต่อวัน",
					"studies_review": "การศึกษาพบว่าการฝึก 10 นาทีต่อวันได้ผลดีที่สุดเมื่อเรียนภาษาใหม่",
					"take_assessment_test": "ทำแบบประเมิน",
					"days_before_invitations": "วันหลังรับคำเชิญ",
					"next": "ถัดไป",
					"will_do_this_later": "ฉันจะทำภายหลัง"
				}
			}
		}
	},
	"dashboard": {
		"reports_overview": "ภาพรวมรายงาน",
		"notifications": "การแจ้งเตือน",
		"overview": "ภาพรวม",
		"manage": "จัดการ",
		"licenses": "Licenses",
		"users": "ผู้ใช้งาน",
		"request_license": "ร้องขอ License",
		"student": {
			"view_class": "ดูชั้นเรียน",
			"view_all_classes": "ดูชั้นเรียนทั้งหมด",
			"goals": {
				"minutes_per_day": "เป้าหมาย { minutes } นาทีต่อวัน",
				"minutes_per_day_value": "การใช้เฉลี่ยของคุณ { minutes } นาทีต่อวัน",
				"days_per_week": "เป้าหมาย {days} วันต่อสัปดาห์",
				"days_per_week_value": "การใช้เฉลี่ยของคุณ {days} วันของการฝึกต่อสัปดาห์",
				"level": "ระดับ {level}",
				"level_value": "เฉลี่ย {level}%"
			},
			"minutes_spend_per_day": "นาทีที่ใช้เฉลี่ยต่อสัปดาห์"
		}
	},
	"charts": {
		"active_users": "ผู้ใช้งานแอคทีฟ",
		"avg_practice_time": "เวลาฝึกเฉลี่ย",
		"avg_eps": "EPS",
		"number_of_lessons": "จำนวนบทเรียน",
		"number_of_seconds": "เวลาที่ใช้",
		"user_eps_score": "EPS",
		"not_active": "ไม่แอคทีฟ",
		"1_4_days": "1-4 วันต่อสัปดาห์",
		"5_5_days": "5 วันต่อสัปดาห์",
		"6_7_days": "6-7 วันต่อสัปดาห์",
		"percentage": "เปอร์เซ็นต์"
	}
}
